import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInfluxdbComponent } from './simple-icons-influxdb.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInfluxdbComponent ],
    exports:      [ SimpleIconsInfluxdbComponent ],
    bootstrap:    []
})
export class SimpleIconsInfluxdbModule {}
